import { type FC } from "react";
import { Card, CardContent, CardHeader } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMarketingComponents } from "@/partner/entities/marketing";
import type { BroadcastFormState } from "../model/broadcastForm";

interface BroadcastAudienceCardProps {
  form: BroadcastFormState;
  onChange: (patch: Partial<BroadcastFormState>) => void;
  disabled: boolean;
  /** Оценка числа адресатов; null, пока её нет (аудитория пуста или невалидна). */
  estimate: number | null;
}

/**
 * Аудитория рассылки: зрители платформы по фильтру и списки контактов.
 * Оценка сверху: отписанные и адреса без согласия отсеются при отправке.
 * Редактор общий с автоматизациями, подставляется страницей.
 */
export const BroadcastAudienceCard: FC<BroadcastAudienceCardProps> = ({
  form,
  onChange,
  disabled,
  estimate,
}) => {
  const { t } = useTranslation();
  const { AudienceEditor } = useMarketingComponents();

  return (
    <Card elevation={0}>
      <CardHeader
        title={t("broadcasts.audience.title")}
        sx={{ px: 2, pt: 2, pb: 0 }}
      />
      <CardContent sx={{ px: 2, pb: 2, pt: 2 }}>
        <AudienceEditor
          value={form}
          onChange={onChange}
          disabled={disabled}
          estimate={estimate}
        />
      </CardContent>
    </Card>
  );
};
